import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center flex-wrap gap-2" }
const _hoisted_4 = { class: "text-black fw-semibold mb-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "d-print-none d-flex gap-2 mt-2 mt-lg-0" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = {
  key: 0,
  class: "text-center text-muted fs-md-14 py-4"
}
const _hoisted_9 = {
  key: 1,
  class: "alert alert-danger mb-0"
}
const _hoisted_10 = { class: "row g-3 mb-4" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "info-bloc h-100" }
const _hoisted_13 = { class: "info-ligne" }
const _hoisted_14 = { class: "info-ligne" }
const _hoisted_15 = { class: "info-ligne" }
const _hoisted_16 = { class: "info-ligne" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "info-bloc h-100" }
const _hoisted_19 = { class: "info-ligne" }
const _hoisted_20 = { class: "info-ligne" }
const _hoisted_21 = { class: "info-ligne" }
const _hoisted_22 = {
  key: 1,
  class: "text-muted mb-0"
}
const _hoisted_23 = { class: "col-6 col-lg-3" }
const _hoisted_24 = { class: "kpi kpi-neutre" }
const _hoisted_25 = { class: "kpi-value" }
const _hoisted_26 = { class: "col-6 col-lg-3" }
const _hoisted_27 = { class: "kpi kpi-entree" }
const _hoisted_28 = { class: "kpi-value text-success" }
const _hoisted_29 = { class: "col-6 col-lg-3" }
const _hoisted_30 = { class: "kpi kpi-sortie" }
const _hoisted_31 = { class: "kpi-value text-danger" }
const _hoisted_32 = { class: "col-6 col-lg-3" }
const _hoisted_33 = { class: "kpi kpi-theorique" }
const _hoisted_34 = { class: "kpi-label" }
const _hoisted_35 = { class: "kpi-value" }
const _hoisted_36 = {
  key: 0,
  class: "info-bloc mb-4"
}
const _hoisted_37 = { class: "info-ligne" }
const _hoisted_38 = { class: "info-ligne" }
const _hoisted_39 = { class: "text-muted mb-0 mt-2" }
const _hoisted_40 = { class: "section-titre" }
const _hoisted_41 = { class: "text-muted fw-normal" }
const _hoisted_42 = { class: "info-bloc" }
const _hoisted_43 = {
  key: 0,
  class: "text-muted py-3"
}
const _hoisted_44 = {
  key: 1,
  class: "table-responsive journal-scroll"
}
const _hoisted_45 = { class: "table table-sm align-middle mb-0 text-nowrap" }
const _hoisted_46 = { class: "text-wrap detail-cell" }
const _hoisted_47 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, [
          _cache[0] || (_cache[0] = _createTextVNode(" Session de caisse")),
          (_ctx.rapport)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " — " + _toDisplayString(_ctx.rapport.session.caisse), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.rapport)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["badge fs-13", _ctx.estFermee ? 'bg-danger' : 'bg-success'])
            }, _toDisplayString(_ctx.estFermee ? 'Fermée' : 'Ouverte (en cours)'), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/OuverturesFermetures",
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Retour à la liste")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.chargement)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Chargement de la session..."))
        : (!_ctx.rapport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Impossible de charger les détails de cette session. "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[19] || (_cache[19] = _createElementVNode("h6", { class: "section-titre" }, "Informations générales", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "fw-bold mb-2" }, "Ouverture", -1)),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", null, "Date", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.format_date(_ctx.rapport.session.dateOuverture)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, "Ouverte par", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.rapport.session.ouvertPar || '—'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", null, "Personnes présentes", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.listePersonnes(_ctx.rapport.session.personnesOuverture)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "Observation", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.rapport.session.observations || 'Aucune'), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "fw-bold mb-2" }, "Fermeture", -1)),
                    (_ctx.estFermee)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_19, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Date", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.format_date(_ctx.rapport.session.dateFin)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Personnes présentes", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.listePersonnes(_ctx.rapport.session.personnesFermeture)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Observation", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.rapport.session.observationsFin || 'Aucune'), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("p", _hoisted_22, "La session est toujours ouverte."))
                  ])
                ])
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("h6", { class: "section-titre" }, "Point général", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["row g-3", _ctx.estFermee ? 'mb-3' : 'mb-4'])
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "kpi-label" }, "Fond de caisse", -1)),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.separateur(_ctx.rapport.fondDeCaisse)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "kpi-label" }, "Entrées", -1)),
                    _createElementVNode("div", _hoisted_28, "+ " + _toDisplayString(_ctx.separateur(_ctx.rapport.totaux.entrees)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "kpi-label" }, "Sorties", -1)),
                    _createElementVNode("div", _hoisted_31, "− " + _toDisplayString(_ctx.separateur(_ctx.rapport.totaux.sorties)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.estFermee ? 'Solde théorique' : 'Solde actuel'), 1),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.separateur(_ctx.rapport.soldeTheorique)), 1)
                  ])
                ])
              ], 2),
              (_ctx.estFermee)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "fw-bold mb-2" }, "Comptage à la fermeture", -1)),
                    _createElementVNode("div", _hoisted_37, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "Solde théorique", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.separateur(_ctx.rapport.soldeTheorique)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", null, "Solde compté", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.separateur(_ctx.rapport.soldeCompte ?? 0)), 1)
                    ]),
                    _createElementVNode("strong", {
                      class: _normalizeClass(_ctx.rapport.ecart === 0 ? 'text-success' : 'text-danger')
                    }, _toDisplayString(_ctx.formatEcart(_ctx.rapport.ecart ?? 0)), 3),
                    _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.messageEcart), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h6", _hoisted_40, [
                _cache[17] || (_cache[17] = _createTextVNode(" Mouvements de caisse ")),
                _createElementVNode("span", _hoisted_41, "(" + _toDisplayString(_ctx.nbMouvements) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                (_ctx.groupes.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Aucun mouvement enregistré."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("table", _hoisted_45, [
                        _cache[18] || (_cache[18] = _createElementVNode("thead", { class: "table-light" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Date et heure"),
                            _createElementVNode("th", null, "Opération"),
                            _createElementVNode("th", null, "Détail"),
                            _createElementVNode("th", null, "Caissier"),
                            _createElementVNode("th", { class: "text-end" }, "Montant"),
                            _createElementVNode("th", { class: "text-end" }, "Solde après")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupes, (g) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: g.cle
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.lignes, (m, i) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: m.id,
                                  class: _normalizeClass({ 'groupe-debut': i === 0, 'groupe-lie': g.lignes.length > 1 })
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDateHeure(m.date)), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.libelleType(m.type)), 1),
                                  _createElementVNode("td", _hoisted_46, _toDisplayString(m.motif || m.refCommande || '—'), 1),
                                  _createElementVNode("td", null, _toDisplayString(m.caissier || '—'), 1),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["text-end fw-semibold", m.sens === 'ENTREE' ? 'text-success' : 'text-danger'])
                                  }, _toDisplayString(m.sens === 'ENTREE' ? '+' : '−') + " " + _toDisplayString(_ctx.separateur(m.montant)), 3),
                                  _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.separateur(m.soldeApres)), 1)
                                ], 2))
                              }), 128))
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ]))
              ])
            ], 64))
    ])
  ]))
}